// ----------------------------------------------------------------------

export const HEADER = {
  H_MOBILE: 32,
  H_DESKTOP: 40,
  H_DESKTOP_OFFSET: 40 - 8,
};

export const NAV = {
  W_VERTICAL: 215,
  W_MINI: 72,
};
